<template>
  <p class="a-input a-input--disabled ">
    {{$t('form.notifications.tender-modified', {tenderName, tenderNumber})}}
  </p>
</template>

<script>
  export default {
    props: {
      data: Object,
      required: true
    },

    computed: {
      tenderName() {
        return this.data.name;
      },

      tenderNumber() {
        return this.data.num;
      },

      tenderId() {
        return this.data.tender;
      }
    },

    methods: {
      onClick() {
        this.$router.push({
          name: 'purchases-public-tender-details',
          params: {
            tenderId: this.tenderId,
            tab: 'overview'
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
